import React from 'react'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import tableCellClasses  from '@mui/material/TableCell';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


const TramitesHistoria = ({recurso}) => {

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 10,
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));


  return (
    
       <TableContainer component={Paper} >
        <Table sx={{ minWidth: 500 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="left"  key="Etapa" ><h1 style={{ fontSize: 14, fontWeight: "bold", textAlign: "left", paddingTop: "2px" }}>Etapa</h1></StyledTableCell>
              <StyledTableCell align="left"  key="Inicio"><h1 style={{ fontSize: 14, fontWeight: "bold", textAlign: "left", paddingTop: "2px" }}>Inicio</h1></StyledTableCell>
              <StyledTableCell align="left"  key="Termino"><h1 style={{ fontSize: 14, fontWeight: "bold", textAlign: "left", paddingTop: "2px" }}>Termino</h1></StyledTableCell>
              <StyledTableCell align="left"  key="Responsable"><h1 style={{ fontSize: 14, fontWeight: "bold", textAlign: "left", paddingTop: "2px" }}>Responsable</h1></StyledTableCell>
            </TableRow>
          </TableHead>
              <TableBody>
                    {recurso.map(item => (
                    <StyledTableRow key={[item.etapa, '-', item.inicio].join()}  >
                      <StyledTableCell align="left"><h1 style={{ fontSize: 14, fontWeight: "normal", textAlign: "left", paddingTop: "2px" }}>{item.etapa}</h1></StyledTableCell>
                      <StyledTableCell align="left">{item.inicio}</StyledTableCell>
                      <StyledTableCell align="left">{item.fin}</StyledTableCell>
                      <StyledTableCell align="left">{item.responsable}</StyledTableCell>
                    </StyledTableRow>
                     ))}
                 
              </TableBody>
        </Table>
      </TableContainer>

      
   
  )
}

export default TramitesHistoria
